import React from 'react';
import cn from 'classnames';
import styles from './Contacts.scss';

import { formatPhoneNumber } from 'utils';
import iconContact from 'assets/images/icons/icon-user.svg';
import iconLink from 'assets/images/icons/icon-link.svg';
import { useTranslation } from 'react-i18next';

const Contacts = ({ className, building, print }) => {
  const { contacts, official_site } = building.data;
  const { t } = useTranslation();

  const list = contacts && contacts.length ? contacts.map((item, i) => (
    <div className={styles.Inner} key={i}>
      <div className={styles.Top}>
        <div className={styles.Avatar}>
          <img alt="contact-men" src={iconContact} />
        </div>
        <div className={styles.Column}>
          <div className={styles.Name}> {item.name} </div>
          <div className={styles.Label}> {item.position} </div>
        </div>
      </div>

      {item.phone ? (
        <div className={styles.Item}>
          <a href={`tel:${item.phone.replace(/-|\s/g, '')}`} className={styles.Phone}>{formatPhoneNumber(item.phone)}</a>
        </div>
        ) : null}
      {item.phone2 ? (
        <div className={styles.Item}>
          <a href={`tel:${item.phone2.replace(/-|\s/g, '')}`} className={styles.Phone}>{formatPhoneNumber(item.phone2)}</a>
        </div>
        ) : null}
      {item.email ? (
        <div className={styles.Item}>
          <a href={`mailto:${item.email}`} className={styles.Mail}> {item.email}</a>
        </div>
        ) : null}
      {item.email2 ? (
        <div className={styles.Item}>
          <a href={`mailto:${item.email2}`} className={styles.Mail}> {item.email2}</a>
        </div>
        ) : null}
    </div>
  )) : (
    <div className={styles.NotFound}>
      <div className={styles.NotFoundText}>
        {t('components.building.main.contacts.button')}
      </div>
    </div>
  );

  const link = `http://${official_site.replace(/http(s)?:\/\//, '')}`;

  return (
    <div className={cn(styles.Contacts, className, { [styles.ContactsPrint]: print })}>
      <h3 className={styles.Title}>
        {t('components.building.main.contacts.contacts')}
        {official_site ? (<a href={link} className={cn(styles.SiteLink, styles.NotMobile)} target="_blank">{t('components.building.main.contacts.site')}<img src={iconLink} alt="" /></a>) : ''}
      </h3>
      <div className={styles.InnerWrap}>
        {list}
        {official_site ? (<a href={link} className={cn(styles.SiteLink, styles.OnlyMobile)} target="_blank">{t('components.building.main.contacts.site')}<img src={iconLink} alt="" /></a>) : ''}
      </div>
    </div>
  );
};

export default Contacts;



// WEBPACK FOOTER //
// ./src/components/Building/Main/Contacts/Contacts.js